import common_en from './common_en.json'
import common_fr from './common_fr.json'
import cta_en from './cta_en.json'
import cta_fr from './cta_fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'
import intro_en from './intro_en.json'
import intro_fr from './intro_fr.json'
import quote_animation_en from './quote-animation_en.json'
import quote_animation_fr from './quote-animation_fr.json'
import quote_en from './quote_en.json'
import quote_fr from './quote_fr.json'
import start_redirect_en from './start-redirect_en.json'
import start_redirect_fr from './start-redirect_fr.json'

const baseFRFlow_resources = {
  en: {
    ...common_en,
    ...cta_en,
    ...intro_en,
    ...forms_en,
    ...quote_en,
    ...quote_animation_en,
    ...start_redirect_en,
  },
  fr: {
    ...common_fr,
    ...cta_fr,
    ...intro_fr,
    ...forms_fr,
    ...quote_fr,
    ...quote_animation_fr,
    ...start_redirect_fr,
  },
}

export default baseFRFlow_resources
